/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Audio_Extraction_CompleteInputs */

const en_media_import_audio_extraction_complete = /** @type {(inputs: Media_Import_Audio_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio extraction complete.`)
};

const fr_media_import_audio_extraction_complete = /** @type {(inputs: Media_Import_Audio_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraction audio terminee.`)
};

const de_media_import_audio_extraction_complete = /** @type {(inputs: Media_Import_Audio_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audioextraktion abgeschlossen.`)
};

const it_media_import_audio_extraction_complete = /** @type {(inputs: Media_Import_Audio_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrazione audio completata.`)
};

const ru_media_import_audio_extraction_complete = /** @type {(inputs: Media_Import_Audio_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Извлечение аудио завершено.`)
};

const es_media_import_audio_extraction_complete = /** @type {(inputs: Media_Import_Audio_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extracción de audio completada.`)
};

const zh_cn2_media_import_audio_extraction_complete = /** @type {(inputs: Media_Import_Audio_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频提取完成。`)
};

const ja_media_import_audio_extraction_complete = /** @type {(inputs: Media_Import_Audio_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオの抽出が完了しました。`)
};

const hi_media_import_audio_extraction_complete = /** @type {(inputs: Media_Import_Audio_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो निष्कर्षण पूर्ण हो गया।`)
};

const pt_pt2_media_import_audio_extraction_complete = /** @type {(inputs: Media_Import_Audio_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extração de áudio concluída.`)
};

/**
* | output |
* | --- |
* | "Audio extraction complete." |
*
* @param {Media_Import_Audio_Extraction_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_audio_extraction_complete = /** @type {((inputs?: Media_Import_Audio_Extraction_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Audio_Extraction_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_audio_extraction_complete(inputs)
	if (locale === "de") return de_media_import_audio_extraction_complete(inputs)
	if (locale === "it") return it_media_import_audio_extraction_complete(inputs)
	if (locale === "ru") return ru_media_import_audio_extraction_complete(inputs)
	if (locale === "es") return es_media_import_audio_extraction_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_audio_extraction_complete(inputs)
	if (locale === "ja") return ja_media_import_audio_extraction_complete(inputs)
	if (locale === "hi") return hi_media_import_audio_extraction_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_audio_extraction_complete(inputs)
	return en_media_import_audio_extraction_complete(inputs)
});